import { useCallback, useState } from 'react';

import { DUBBING_ERROR_STATUSES, DUBBING_STATUSES } from '@/entities/project';
import { useSpaceCredits } from '@/entities/teamspace';

import { Project } from '@/shared/types/Project';
import { Status } from '@/shared/types/Status';

export const useUserMinutesUpdatingWhenDubbingStarted = () => {
  const [isUserUpdatedWhenDubbingStarted, setIsUserUpdatedWhenDubbingStarted] = useState(false);
  const { refetch: refetchCredits } = useSpaceCredits();

  const resetIsUserUpdatedWhenDubbingStarted = useCallback(() => {
    setIsUserUpdatedWhenDubbingStarted(false);
  }, []);

  const updateUserIfDubbingStatusChanged = useCallback(
    async (project: Project) => {
      // в случае ошибки даббинга идём за юзером чтобы обновились его кредиты
      if (DUBBING_ERROR_STATUSES.includes(project.status)) {
        setIsUserUpdatedWhenDubbingStarted(false);
        await refetchCredits();
      }

      // если даббинг начался, то идем за юзером чтобы обновились его кредиты
      if (!isUserUpdatedWhenDubbingStarted && [Status.mergingDone, ...DUBBING_STATUSES].includes(project.status)) {
        setIsUserUpdatedWhenDubbingStarted(true);
        await refetchCredits();
      }
    },
    [isUserUpdatedWhenDubbingStarted, refetchCredits],
  );

  return { resetIsUserUpdatedWhenDubbingStarted, updateUserIfDubbingStatusChanged };
};
